import { render, staticRenderFns } from "./EngineeringInstallationDetail.vue?vue&type=template&id=5a848788&scoped=true"
import script from "./EngineeringInstallationDetail.vue?vue&type=script&lang=js"
export * from "./EngineeringInstallationDetail.vue?vue&type=script&lang=js"
import style0 from "./EngineeringInstallationDetail.vue?vue&type=style&index=0&id=5a848788&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a848788",
  null
  
)

export default component.exports